'use client';

import { useEffect, useState } from "react";
import { AppBar, IconButton, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import { PAPER_BACKGROUND } from "@/src/constant/constant";
import DesktopMenu from "@/src/components/journal-site/_partials/header/journal-menu/desktop-menu/desktop-menu";
import DrawerMenu from "@/src/components/journal-site/_partials/header/journal-menu/drawer-menu/drawer-menu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-duotone-svg-icons";
import HeaderTitle from "@/src/components/journal-site/_partials/header/journal-menu/header-title/header-title";
import JournalMenuProps from "@/src/_types/journal-menu-props";

const JournalMenu = ({ menuItems, authorGuide, journalTitle, journalSubtitle, submission }
    : JournalMenuProps) => {
    const theme = useTheme();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isFixed, setIsFixed] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
    const toggleDrawer = (open: boolean) => setDrawerOpen(open);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                document.querySelector('#journal-navigation-container')?.classList.add('position-fixed');
                setIsFixed(true);
            } else {
                document.querySelector('#journal-navigation-container')?.classList.remove('position-fixed');
                setIsFixed(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <AppBar
            component={"div"}
            sx={{
                minWidth: '270px',
                maxWidth: "1400px",
                m: "auto",
                backgroundColor: theme.palette.custom?.backgroundColorJournalMenu,
                backgroundImage: `url(${PAPER_BACKGROUND})`,
                borderBottomLeftRadius: theme.shape.borderRadius,
                borderBottomRightRadius: theme.shape.borderRadius,
                position: isFixed ? 'fixed' : 'static',
                top: isFixed ? 0 : 'auto',
                left: isFixed ? 0 : 'auto',
                right: isFixed ? 0 : 'auto',
                zIndex: isFixed ? theme.zIndex.appBar : 'auto',
                width: '100%',
                transform: isFixed ? 'translateY(0)' : 'none',
                transition: 'all 0.3s ease',
                padding: '0 !important',
            }}
        >
            {
                !isMobile &&
                <HeaderTitle
                    title={journalTitle}
                    subtitle={journalSubtitle}
                    isFixed={isFixed}
                    authorGuide={authorGuide}
                    submission={submission}
                />
            }
            <Toolbar
                sx={{
                    paddingX: '.75rem !important',
                    minHeight: '0 !important'
                }}
            >
                {
                    isMobile ? (
                        <>
                            <IconButton
                                size="large"
                                aria-label="menu"
                                sx={{ mr: .5 }}
                                onClick={() => toggleDrawer(true)}
                            >
                                <FontAwesomeIcon 
                                    icon={faBars} 
                                    color={'custom.teal'} 
                                />
                            </IconButton>
                            <Typography
                                variant="fs5"
                                component="h1"
                                sx={{
                                    fontWeight: 700,
                                    textShadow: "2px 2px 0 #0c7f8b",
                                    color: theme.palette.custom?.textColorJournalMenu,
                                }}
                            >
                                {
                                    journalTitle
                                }
                            </Typography>
                        </>
                    ) : (
                        <DesktopMenu
                            menuItems={menuItems}
                            authorGuide={authorGuide}
                            submission={submission}
                            isFixed={isFixed}
                        />
                    )
                }
            </Toolbar>
            {
                isMobile && (
                    <DrawerMenu
                        open={drawerOpen}
                        toggleDrawer={toggleDrawer}
                        menuItems={menuItems}
                        journalTitle={journalTitle}
                        journalSubtitle={journalSubtitle}
                        authorGuide={authorGuide}
                        submission={submission}
                    />
                )
            }
        </AppBar>
    );
};

export default JournalMenu;
